export default __webpack_public_path__ + "static/media/slider-arrow-next.753e8397.svg";